/*
 * df-search.js — Buscador predictivo del df-search-modal.
 * Conecta el modal con /search/suggest.json y gestiona resultados visuales.
 */
(function () {
  'use strict';

  var RECENT_KEY = 'df_search_recents';
  var MAX_RECENT = 5;
  var DEBOUNCE_MS = 200;
  var MAX_COLLECTIONS = 2;
  var MAX_PAGES = 3;
  var MAX_ANSWERS = 2;

  // Páginas que existen pero no son un destino para quien busca un regalo:
  // las versiones en portugués, las «Track your order» en inglés que dejó una
  // app, los textos legales de GDPR y compañía, y las comparativas con la
  // competencia, que son para Google, no para el cliente que ya está dentro.
  var PAGE_SKIP = /(portugal|^track-your-order|gdpr|privacy|pipeda|lgpd|appi|ccpa|^cookies$|^contact$|^dondefue-vs-|^comparativa-)/;
  // Las herramientas (calculadoras, generadores, tests) son la mitad del
  // tráfico de la web, pero no son lo que busca quien escribe «cuadro
  // pareja». Se quedan, detrás de las landings, salvo que las pidas.
  var PAGE_TOOL = /^(calculadora|generador|test-|coordenadas-decimales|quiz)/;
  var WANTS_TOOL = /calcul|generador|test|quiz|coordenad/;

  // Lo que no sale nunca en el buscador: el papel de regalo (se decide en la
  // cesta, no buscándolo) y cualquier cosa agotada.
  var HIDDEN_HANDLES = ['gift-wrap'];
  function isListable(p) {
    if (!p) return false;
    if (HIDDEN_HANDLES.indexOf(p.handle) !== -1) return false;
    return p.available !== false;
  }

  var modal, input, clearBtn, defaults, results, body;
  var productsGroup, productsList, productsCount;
  var collectionsGroup, collectionsList;
  var pagesGroup, pagesList;
  var loadingEl, emptyEl, seeAllEl, seeAllLink;
  var emptyQ, emptyFull, emptyTop, topList;
  var answersGroup, answerCards;
  var recentGroup, recentChips;
  var intents = [];

  // Lo que había en pantalla en el pintado anterior, por grupo. Sirve para
  // animar solo lo que entra nuevo: si «novi» y «novia» traen tres fichas
  // en común, esas tres se quedan quietas y solo suben las otras. Animarlo
  // todo a cada tecla era un parpadeo.
  var shown = { collections: {}, products: {}, pages: {} };
  var lastApiCollections = [];
  var skelTimer = null;
  var SKELETON_DELAY = 300;

  var currentTimer = null;
  var currentQuery = '';
  var trackedQuery = '';
  var lastAbort = null;

  function init() {
    modal = document.getElementById('df-search-modal');
    if (!modal) return;

    input = modal.querySelector('[data-df-search-input]');
    clearBtn = modal.querySelector('[data-df-search-clear]');
    defaults = modal.querySelector('[data-df-search-defaults]');
    results = modal.querySelector('[data-df-search-results]');
    body = modal.querySelector('[data-df-search-body]');

    productsGroup = modal.querySelector('[data-df-search-products-group]');
    productsList = modal.querySelector('[data-df-search-products]');
    productsCount = modal.querySelector('[data-df-search-products-count]');
    collectionsGroup = modal.querySelector('[data-df-search-collections-group]');
    collectionsList = modal.querySelector('[data-df-search-collections]');
    pagesGroup = modal.querySelector('[data-df-search-pages-group]');
    pagesList = modal.querySelector('[data-df-search-pages]');

    loadingEl = modal.querySelector('[data-df-search-loading]');
    emptyEl = modal.querySelector('[data-df-search-empty]');
    seeAllEl = modal.querySelector('[data-df-search-see-all]');
    seeAllLink = modal.querySelector('[data-df-search-see-all-link]');
    emptyQ = modal.querySelector('[data-df-search-empty-q]');
    emptyFull = modal.querySelector('[data-df-search-empty-full]');
    emptyTop = modal.querySelector('[data-df-search-empty-top]');
    topList = modal.querySelector('.df-search-modal__products--top');

    answersGroup = modal.querySelector('[data-df-search-answers-group]');
    answerCards = answersGroup ? Array.prototype.slice.call(answersGroup.querySelectorAll('[data-df-answer]')) : [];

    recentGroup = modal.querySelector('[data-df-search-recent-group]');
    recentChips = modal.querySelector('[data-df-search-recents]');

    intents = parseIntents(modal.getAttribute('data-df-search-intents'));

    if (!input) return;

    renderRecents();

    // Input
    input.addEventListener('input', onInputChange);
    input.addEventListener('keydown', onKeyDown);

    // Clear button
    if (clearBtn) {
      clearBtn.addEventListener('click', function () {
        input.value = '';
        input.focus();
        onInputChange();
      });
    }

    // Suggest chips (top + recents)
    modal.addEventListener('click', function (e) {
      var sug = e.target.closest('[data-df-search-suggest]');
      if (sug) {
        input.value = sug.getAttribute('data-df-search-suggest');
        input.focus();
        onInputChange();
        return;
      }

      // Por que «Recientes» no salia nunca
      // ---------------------------------
      // La busqueda solo se guardaba en el `submit` del formulario, es decir,
      // solo si pulsabas Enter y te ibas a /search. Pero el buscador
      // predictivo esta hecho justo para lo contrario: escribes, ves la ficha
      // y la tocas. Ese camino —el de la inmensa mayoria, y practicamente el
      // unico en movil, donde el teclado no ensena ningun Enter evidente— no
      // guardaba nada. De ahi que el grupo naciera `hidden` y se quedara
      // asi para siempre: no es que no se pintara, es que no habia nada que
      // pintar.
      //
      // Se guarda al NAVEGAR desde un resultado, que es cuando la busqueda ha
      // servido para algo. Un termino que no llevo a ninguna parte no merece
      // volver a salir.
      var hit = e.target.closest('[data-df-search-result], [data-df-search-see-all-link], [data-df-search-empty-full]');
      if (hit && currentQuery) {
        saveRecent(currentQuery);
        // Y se mide aquí también. Antes el evento `search` solo salía al
        // pulsar Enter, que es el camino minoritario: lo que la gente busca
        // y encuentra desde el desplegable no llegaba a ninguna analítica.
        if (trackedQuery !== currentQuery) {
          trackedQuery = currentQuery;
          trackSearch(currentQuery);
        }
      }
    });

    // Clear recents
    var clearRecent = modal.querySelector('[data-df-search-clear-recent]');
    if (clearRecent) {
      clearRecent.addEventListener('click', function () {
        localStorage.removeItem(RECENT_KEY);
        renderRecents();
      });
    }

    // Form submit (Enter → /search?q=)
    var form = modal.querySelector('[data-df-search-form]');
    if (form) {
      form.addEventListener('submit', function (e) {
        var q = input.value.trim();
        if (q) {
          saveRecent(q);
          if (trackedQuery !== q) { trackedQuery = q; trackSearch(q); }
        }
        // Form action ya es /search, dejamos submit nativo
      });
    }

    // Reset state when modal opens (handled by dondefue.js, here we just observe)
    var mo = new MutationObserver(function () {
      if (modal.hidden) return;
      // Repintar las recientes cada vez que se abre, no solo al cargar la
      // pagina. Volver atras desde una ficha no siempre recarga —el bfcache
      // devuelve la pagina tal cual la dejaste— y sin esto la busqueda que
      // acabas de hacer no aparecia hasta la siguiente recarga completa.
      renderRecents();
      if (document.activeElement !== input) {
        setTimeout(function () { input && input.focus(); }, 80);
      }
    });
    mo.observe(modal, { attributes: true, attributeFilter: ['hidden'] });
  }

  function onInputChange() {
    var q = input.value.trim();
    currentQuery = q;
    if (clearBtn) clearBtn.hidden = !q;

    if (currentTimer) clearTimeout(currentTimer);

    if (!q) {
      showDefaults();
      return;
    }

    currentTimer = setTimeout(function () { runSearch(q); }, DEBOUNCE_MS);
  }

  function showDefaults() {
    stopLoading();
    defaults.hidden = false;
    results.hidden = true;
    // Se vacía lo de la búsqueda anterior: si no, al escribir otra cosa se
    // vería medio segundo lo de antes mientras carga lo nuevo.
    productsList.innerHTML = '';
    pagesList.innerHTML = '';
    collectionsList.innerHTML = '';
    productsGroup.hidden = true;
    pagesGroup.hidden = true;
    collectionsGroup.hidden = true;
    emptyEl.hidden = true;
    seeAllEl.hidden = true;
    shown = { collections: {}, products: {}, pages: {} };
    lastApiCollections = [];
    renderRecents();
  }

  function showResults() {
    defaults.hidden = true;
    results.hidden = false;
  }

  // Mientras busca, lo de antes se queda (un poco apagado) y una línea roja
  // recorre el borde del campo. Antes cada tecla vaciaba la lista y ponía
  // tres bloques grises: la pantalla parpadeaba aunque la respuesta tardara
  // 80 ms. Los grises siguen, pero solo si no hay nada que enseñar y la
  // búsqueda pasa de 300 ms.
  function showLoading(q) {
    showResults();
    modal.classList.add('is-searching');
    // La respuesta rápida y la colección no dependen de la red: salen en la
    // misma tecla, mientras los productos cargan debajo.
    renderAnswers(q);
    renderCollections(q, lastApiCollections);
    clearTimeout(skelTimer);
    skelTimer = setTimeout(function () {
      if (!modal.classList.contains('is-searching') || !productsGroup.hidden) return;
      loadingEl.hidden = false;
      emptyEl.hidden = true;
      seeAllEl.hidden = true;
    }, SKELETON_DELAY);
  }

  function stopLoading() {
    clearTimeout(skelTimer);
    modal.classList.remove('is-searching');
    loadingEl.hidden = true;
  }

  // Marca como nueva la fila que no estaba en el pintado anterior del mismo
  // grupo. El índice escalona la entrada (30 ms por fila, tope en ocho: una
  // cascada más larga ya se lee como lentitud).
  function keyOf(url) { return String(url || '').split('?')[0]; }
  function tagEntry(el, key, prev, next, counter) {
    next[key] = true;
    if (prev[key]) return false;
    el.classList.add('is-new');
    el.style.setProperty('--df-i', String(Math.min(counter.n++, 8)));
    return true;
  }

  // === Spanish-friendly normalization & synonyms ===
  // Map accents → base letters
  function stripAccents(s) {
    if (!s) return '';
    return s.normalize('NFD').replace(/[̀-ͯ]/g, '');
  }

  // «Regalo para mi NOVIA!» → ['regalo', 'para', 'mi', 'novia']. Sin tildes
  // ni signos, igual que las palabras de las reglas (ver df-search-match).
  function foldTokens(q) {
    return stripAccents(String(q || '')).toLowerCase().split(/[^a-z0-9]+/).filter(Boolean);
  }

  // Misma sintaxis que `snippets/df-search-match.liquid`: `novia` es la
  // palabra entera, `cumple*` un prefijo y `casa+nueva` una frase.
  // Una diferencia a propósito: aquí se escribe letra a letra, así que la
  // última palabra, si ya tiene cuatro letras, también vale a medias
  // («novi» ya ofrece parejas). La página de resultados recibe la búsqueda
  // entera y no la necesita.
  function matchWords(words, tokens) {
    if (!words || !tokens.length) return false;
    var norm = ' ' + tokens.join(' ') + ' ';
    var last = tokens[tokens.length - 1];
    var list = words.split(/\s+/);
    for (var i = 0; i < list.length; i++) {
      var w = list[i];
      if (!w) continue;
      var isPrefix = w.charAt(w.length - 1) === '*';
      var ww = w.replace(/\*$/, '').replace(/\+/g, ' ');
      if (isPrefix ? norm.indexOf(' ' + ww) !== -1 : norm.indexOf(' ' + ww + ' ') !== -1) return true;
      if (last.length >= 4 && ww.indexOf(' ') === -1 && ww.length > last.length && ww.indexOf(last) === 0) return true;
    }
    return false;
  }

  function parseIntents(raw) {
    return String(raw || '').split('\n').map(function (line) {
      var parts = line.split('|');
      if (parts.length < 3) return null;
      return { handle: parts[0].trim(), label: parts[1].trim(), words: parts[2].trim() };
    }).filter(function (x) { return x && x.handle && x.words; });
  }

  function detectIntents(q) {
    var tokens = foldTokens(q);
    return intents.filter(function (it) { return matchWords(it.words, tokens); });
  }

  function renderAnswers(q) {
    if (!answersGroup) return 0;
    var tokens = foldTokens(q);
    var shown = 0;
    answerCards.forEach(function (card) {
      var on = shown < MAX_ANSWERS && matchWords(card.getAttribute('data-df-answer'), tokens);
      card.hidden = !on;
      if (on) shown++;
    });
    answersGroup.hidden = shown === 0;
    return shown;
  }

  // Colecciones: primero las de la intención («novia» → parejas), después las
  // que devuelva Shopify por título, sin repetir. Dos como mucho, que van
  // encima de los productos y no deben empujarlos fuera de la pantalla.
  function renderCollections(q, apiCollections) {
    var seen = {};
    var list = [];
    detectIntents(q).forEach(function (it) {
      if (seen[it.handle]) return;
      seen[it.handle] = true;
      list.push({ url: '/collections/' + it.handle, title: it.label, plain: true });
    });
    (apiCollections || []).forEach(function (c) {
      if (!c || seen[c.handle]) return;
      seen[c.handle] = true;
      list.push({ url: c.url, title: c.title });
    });
    list = list.slice(0, MAX_COLLECTIONS);

    var prev = shown.collections, next = {}, counter = { n: 0 };
    collectionsList.innerHTML = '';
    list.forEach(function (c) {
      var row = document.createElement('a');
      row.className = 'df-search-modal__row';
      row.setAttribute('data-df-search-result', '');
      row.href = c.url;
      row.innerHTML = '<span>' + (c.plain ? escapeHtml(c.title) : highlight(c.title, q)) + '</span>' + CHEVRON;
      tagEntry(row, keyOf(c.url), prev, next, counter);
      collectionsList.appendChild(row);
    });
    shown.collections = next;
    collectionsGroup.hidden = list.length === 0;
    return list.length;
  }

  var CHEVRON = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="m9 6 6 6-6 6"/></svg>';

  // Common Spanish synonym pairs (bidirectional)
  // If user types one, also try the other.
  var SYNONYMS = {
    'mama': ['mamá', 'madre'], 'mamá': ['mama', 'madre'], 'madre': ['mama', 'mamá'],
    'papa': ['papá', 'padre'], 'papá': ['papa', 'padre'], 'padre': ['papa', 'papá'],
    'cuadro': ['lámina', 'poster', 'lamina'], 'lamina': ['cuadro', 'lámina', 'poster'], 'lámina': ['cuadro', 'lamina', 'poster'],
    'poster': ['cuadro', 'lámina', 'lamina'], 'póster': ['cuadro', 'lámina'],
    'taza': ['mug', 'tazas', 'tazas mágicas', 'taza mágica'],
    'sudadera': ['hoodie', 'jersey'],
    'camiseta': ['tshirt', 't-shirt'],
    'pareja': ['novia', 'novio', 'esposa', 'esposo', 'love'],
    'novio': ['pareja', 'love'], 'novia': ['pareja', 'love'],
    'aniversario': ['aniversarios', 'love', 'pareja'],
    'cumpleanos': ['cumpleaños', 'cumple', 'bday'], 'cumpleaños': ['cumpleanos', 'cumple', 'bday'],
    'navidad': ['navidades', 'christmas'],
    'boda': ['bodas', 'wedding', 'casamiento'], 'bodas': ['boda', 'wedding'],
    'amigo': ['amigos', 'amigas', 'amig@'], 'amigos': ['amigo', 'amig@'],
    'nacimiento': ['bebé', 'bebe', 'recién nacido', 'baby'],
    'bebé': ['bebe', 'nacimiento', 'baby'],
    'bebe': ['bebé', 'nacimiento', 'baby'],
    'cancion': ['canción', 'songs'], 'canción': ['cancion'],
    'mapa': ['mapas', 'coordenadas', 'donde fue', 'localización', 'ciudad'],
    'foto': ['fotos', 'imagen', 'imágenes'],
    'regalo': ['regalos', 'gift', 'presente'],
    'corazon': ['corazón', 'love', 'amor'], 'corazón': ['corazon', 'love', 'amor'],
    'estelar': ['estrella', 'estrellas', 'cielo', 'mapa estelar'],
    'tio': ['tío', 'tía'], 'tia': ['tía', 'tío'],
    'abuelo': ['abuelos', 'abuela', 'yayo', 'yaya'],
    'abuela': ['abuelas', 'yaya', 'abuelo'],
    'hijo': ['hijos', 'hija', 'hijas'], 'hija': ['hijas', 'hijo'],
    'familia': ['familiar', 'familiares'],
    'personalizado': ['personalizada', 'personalizable', 'custom']
  };

  // `limit_scope=each`: sin él, el límite es para TODO junto. Con 6 y tres
  // tipos pedidos, Shopify devolvía 3 productos y 3 páginas, y como el papel
  // de regalo se oculta, «regalo novia» enseñaba 2 productos. Ahora el límite
  // es por tipo. Se pide uno de más porque el filtro de abajo (papel de
  // regalo, agotados, páginas que sobran) siempre se lleva alguno.
  function buildSuggestUrl(q, limit) {
    return '/search/suggest.json' +
      '?q=' + encodeURIComponent(q) +
      '&resources[type]=product,collection,page' +
      '&resources[limit]=' + Math.min(10, limit + 2) +
      '&resources[limit_scope]=each' +
      '&resources[options][unavailable_products]=last' +
      '&resources[options][fields]=title,product_type,variants.title,vendor,body,tag' +
      '&resources[options][prefix]=last';
  }

  function pickPages(pages, q) {
    var list = (pages || []).filter(function (p) { return p && !PAGE_SKIP.test(p.handle || ''); });
    if (!WANTS_TOOL.test(foldTokens(q).join(' '))) {
      var isTool = function (p) { return PAGE_TOOL.test(p.handle || ''); };
      list = list.filter(function (p) { return !isTool(p); }).concat(list.filter(isTool));
    }
    return list.slice(0, MAX_PAGES);
  }

  // Los títulos SEO de las landings llevan la marca al final
  // («… | Donde Fue», «… — Donde Fue»). Dentro de la propia tienda sobra.
  function cleanPageTitle(t) {
    return String(t || '').replace(/\s*[|—–-]\s*Donde Fue\s*$/i, '').trim();
  }

  function fetchOnce(url, signal) {
    return fetch(url, { signal: signal, headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.json(); });
  }

  function countResults(data) {
    var r = (data && data.resources && data.resources.results) || {};
    return (r.products || []).filter(isListable).length + (r.collections || []).length + pickPages(r.pages, '').length;
  }

  // Build alternative queries to try when exact yields nothing.
  function buildFallbackQueries(q) {
    var queries = [];
    var seen = {};
    function add(s) {
      var key = (s || '').toLowerCase().trim();
      if (!key || seen[key]) return;
      seen[key] = true;
      queries.push(s);
    }

    // 1. Accent-stripped
    var stripped = stripAccents(q);
    if (stripped !== q) add(stripped);

    // 2. Add accents (heuristic): try synonyms of each token
    var tokens = q.toLowerCase().split(/\s+/).filter(Boolean);
    var anySyn = false;
    var synTokens = tokens.map(function (t) {
      var bare = stripAccents(t);
      var syn = SYNONYMS[t] || SYNONYMS[bare];
      if (syn && syn.length) {
        anySyn = true;
        // First synonym substitutes
        return syn[0];
      }
      return t;
    });
    if (anySyn) add(synTokens.join(' '));

    // 3. Wildcard suffix (e.g. "regal" → "regal*")
    var lastToken = tokens[tokens.length - 1];
    if (lastToken && lastToken.length >= 3 && !/\*$/.test(lastToken)) {
      var wild = tokens.slice(0, -1).concat(lastToken + '*').join(' ');
      add(wild);
    }

    // 4. Single-token searches (each word independently) — broader OR
    if (tokens.length > 1) {
      tokens.forEach(function (t) {
        if (t.length >= 3) add(t);
      });
    }

    return queries;
  }

  function runSearch(q) {
    if (lastAbort) try { lastAbort.abort(); } catch (e) {}
    lastAbort = ('AbortController' in window) ? new AbortController() : null;

    showLoading(q);

    var limit = Number(window.dfSearchLimit || 6);

    // Strategy: try exact first, then fallback chain.
    var queries = [q].concat(buildFallbackQueries(q));
    var attemptIdx = 0;

    function tryNext() {
      if (attemptIdx >= queries.length) {
        // All strategies exhausted → render with intents fallback
        renderResults({ resources: { results: { products: [], collections: [], pages: [] } } }, q, /*usedFallback*/ true);
        return;
      }
      var candidate = queries[attemptIdx++];
      var url = buildSuggestUrl(candidate, limit);
      fetchOnce(url, lastAbort ? lastAbort.signal : undefined)
        .then(function (data) {
          if (q !== currentQuery) return; // race condition
          if (countResults(data) > 0) {
            renderResults(data, q, attemptIdx > 1);
          } else {
            tryNext();
          }
        })
        .catch(function (err) {
          if (err && err.name === 'AbortError') return;
          tryNext();
        });
    }
    tryNext();
  }

  function renderResults(data, q, usedFallback) {
    stopLoading();

    var limit = Number(window.dfSearchLimit || 6);
    var resources = (data && data.resources && data.resources.results) || {};
    var pages = pickPages(resources.pages, q);

    var nAnswers = renderAnswers(q);
    lastApiCollections = resources.collections || [];
    var nCollections = renderCollections(q, lastApiCollections);

    // Si la búsqueda era una pregunta («cuánto tarda el envío») y no pide
    // ningún tipo de regalo, los productos salen porque la palabra está en
    // su descripción, no porque vengan a cuento. Se quedan, pero tres.
    if (nAnswers && !detectIntents(q).length) limit = Math.min(limit, 3);
    var products = (resources.products || []).filter(isListable).slice(0, limit);

    // Products
    var prevP = shown.products, nextP = {}, counterP = { n: 0 };
    productsList.innerHTML = '';
    if (products.length) {
      productsGroup.hidden = false;
      // El aviso de «aproximados» se pintaba y la línea siguiente lo
      // machacaba con `textContent`: nunca llegó a verse. Va después.
      productsCount.textContent = String(products.length);
      if (usedFallback) {
        productsCount.insertAdjacentHTML('beforeend', ' <span class="df-search-modal__hint">· resultados aproximados</span>');
      }
      products.forEach(function (p) {
        var row = document.createElement('a');
        row.className = 'df-search-modal__product-row';
        row.setAttribute('data-df-search-result', '');
        row.href = p.url;
        var src = thumbUrl(p);
        row.innerHTML =
          (src ? '<img src="' + escapeHtml(src) + '" alt="" class="df-search-modal__product-img" loading="lazy" decoding="async" width="56" height="56">' : '<span class="df-search-modal__product-img-empty"></span>') +
          '<span class="df-search-modal__product-info">' +
            '<span class="df-search-modal__product-title">' + highlight(p.title, q) + '</span>' +
            '<span class="df-search-modal__product-meta">' +
              '<span class="df-search-modal__product-price">' + priceLabel(p) + '</span>' +
            '</span>' +
          '</span>' +
          '<span class="df-search-modal__product-cta">' + CHEVRON + '</span>';
        var isNew = tagEntry(row, keyOf(p.url), prevP, nextP, counterP);
        productsList.appendChild(row);
        if (isNew) fadeInImage(row.querySelector('img'));
      });
    } else {
      productsGroup.hidden = true;
    }
    shown.products = nextP;

    // Pages: entran detrás de los productos, no a la vez.
    var prevG = shown.pages, nextG = {}, counterG = { n: 3 };
    pagesList.innerHTML = '';
    if (pages.length) {
      pagesGroup.hidden = false;
      pages.forEach(function (p) {
        var row = document.createElement('a');
        row.className = 'df-search-modal__row';
        row.setAttribute('data-df-search-result', '');
        row.href = p.url;
        row.innerHTML = '<span>' + highlight(cleanPageTitle(p.title), q) + '</span>';
        tagEntry(row, keyOf(p.url), prevG, nextG, counterG);
        pagesList.appendChild(row);
      });
    } else {
      pagesGroup.hidden = true;
    }
    shown.pages = nextG;

    var fullUrl = fullSearchUrl(q);
    var nothing = !products.length && !pages.length && !nCollections && !nAnswers;

    // Sin nada que ofrecer: el estado vacío. Si al menos hay una respuesta o
    // una colección, eso ya es una salida y el «no encontramos» sobra.
    emptyEl.hidden = !nothing;
    if (nothing) {
      if (emptyQ) emptyQ.textContent = '«' + q + '»';
      if (emptyFull) emptyFull.href = fullUrl;
      fillEmptyTop();
    }

    // «Ver todos» solo cuando hay productos: es la puerta a la rejilla
    // completa, y sin productos esa rejilla no tiene nada mejor que ofrecer.
    seeAllEl.hidden = !products.length;
    if (seeAllLink) seeAllLink.href = fullUrl;
  }

  // La foto de una fila nueva aparece con un fundido cuando llega, en vez de
  // pintarse a trozos. Si ya estaba en caché (`complete`), sin fundido: no
  // hay nada que esperar.
  function fadeInImage(img) {
    if (!img || img.complete) return;
    img.classList.add('is-fading');
    var done = function () { img.classList.remove('is-fading'); };
    img.addEventListener('load', done, { once: true });
    img.addEventListener('error', done, { once: true });
  }

  // Lo más regalado, copiado de la pantalla de inicio. Una sola vez: son
  // siempre las mismas cuatro filas.
  function fillEmptyTop() {
    if (!emptyTop || emptyTop.children.length || !topList) return;
    emptyTop.innerHTML = topList.innerHTML;
    Array.prototype.forEach.call(emptyTop.querySelectorAll('a'), function (a) {
      a.setAttribute('data-df-search-result', '');
    });
  }

  // La misma búsqueda que manda el formulario al pulsar Enter, con el
  // prefijo: sin `options[prefix]=last`, «regal» no encuentra «regalo».
  function fullSearchUrl(q) {
    return '/search?q=' + encodeURIComponent(q) +
      '&options%5Bprefix%5D=last&options%5Bunavailable_products%5D=last&type=product%2Carticle%2Cpage';
  }

  function escapeHtml(s) {
    return String(s || '').replace(/[&<>"']/g, function (c) {
      return ({'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;',"'":'&#39;'})[c];
    });
  }

  // Resalta cada palabra, no la frase entera, y sin mirar tildes: antes
  // «regalo novia» no marcaba nada en «Regalos personalizados para Novia»
  // porque buscaba la cadena «regalo novia» tal cual.
  // Se busca sobre el título plegado y se corta el original por las mismas
  // posiciones; por eso hace falta que plegar no cambie la longitud, que es
  // lo que pasa con cualquier texto en NFC (é → e). Si alguna vez no cuadra,
  // se pinta sin resaltar antes que resaltar la letra equivocada.
  function highlight(text, q) {
    var src = String(text || '').normalize('NFC');
    if (!src) return '';
    var folded = stripAccents(src).toLowerCase();
    var tokens = foldTokens(q).filter(function (t) { return t.length >= 2 && !STOPWORDS[t]; });
    if (!tokens.length || folded.length !== src.length) return escapeHtml(src);

    // Solo desde el principio de una palabra, que es como busca Shopify
    // (`prefix=last`). Sin esto, «cuánto tarda el envío» pintaba el «el» de
    // «Estelar».
    var ranges = [];
    tokens.forEach(function (t) {
      var from = 0, at;
      while ((at = folded.indexOf(t, from)) !== -1) {
        if (at === 0 || !/[a-z0-9]/.test(folded.charAt(at - 1))) ranges.push([at, at + t.length]);
        from = at + t.length;
      }
    });
    if (!ranges.length) return escapeHtml(src);
    ranges.sort(function (a, b) { return a[0] - b[0]; });

    var out = '', pos = 0, i, r, end = -1, start = -1;
    for (i = 0; i <= ranges.length; i++) {
      r = ranges[i];
      if (r && r[0] <= end) { end = Math.max(end, r[1]); continue; }
      if (start !== -1) {
        out += escapeHtml(src.slice(pos, start)) + '<mark>' + escapeHtml(src.slice(start, end)) + '</mark>';
        pos = end;
      }
      if (r) { start = r[0]; end = r[1]; }
    }
    return out + escapeHtml(src.slice(pos));
  }

  var STOPWORDS = {};
  'el la los las un una unos unas de del al y o a en con por para mi mis su sus que se es lo le'.split(' ').forEach(function (w) { STOPWORDS[w] = true; });

  function toNumber(v) {
    if (typeof v === 'number') return v;
    if (v == null || v === '') return NaN;
    return parseFloat(String(v).replace(/[^\d.,]/g, '').replace(',', '.'));
  }

  function formatPrice(p) {
    if (typeof p !== 'number' || isNaN(p)) return '';
    return p.toFixed(2).replace('.', ',') + ' €';
  }

  // «desde» cuando el precio varía, igual que las filas de «Lo más regalado»
  // (`df-search-top-row`). Los cuadros van de 29,95 a 39,95 según el tamaño:
  // «29,95 €» a secas prometía un precio que no era el único.
  function priceLabel(p) {
    var min = toNumber(p.price_min != null ? p.price_min : p.price);
    var max = toNumber(p.price_max);
    var s = formatPrice(min);
    if (!s) return '';
    return (max > min ? 'desde ' : '') + s;
  }

  // La foto a 120 px (una miniatura de 56 a doble densidad). Shopify
  // devolvía el original: 459 KB por la de Donde nos Conocimos, a cada
  // búsqueda y en el móvil. Con `width` baja a 15 KB.
  function thumbUrl(p) {
    var u = p.image || (p.featured_image && p.featured_image.url) || '';
    if (!u) return '';
    return u + (u.indexOf('?') === -1 ? '?' : '&') + 'width=120';
  }

  // === RECENTS ===
  function getRecents() {
    try { return JSON.parse(localStorage.getItem(RECENT_KEY) || '[]'); }
    catch (e) { return []; }
  }
  function saveRecent(q) {
    if (!q) return;
    var list = getRecents();
    list = list.filter(function (x) { return x !== q; });
    list.unshift(q);
    list = list.slice(0, MAX_RECENT);
    try { localStorage.setItem(RECENT_KEY, JSON.stringify(list)); } catch (e) {}
  }
  function dropRecent(q) {
    var list = getRecents().filter(function (x) { return x !== q; });
    try { localStorage.setItem(RECENT_KEY, JSON.stringify(list)); } catch (e) {}
    renderRecents();
  }
  function renderRecents() {
    if (!recentGroup || !recentChips) return;
    var list = getRecents();
    if (!list.length) {
      recentGroup.hidden = true;
      return;
    }
    recentGroup.hidden = false;
    recentChips.innerHTML = '';
    list.forEach(function (q) {
      // Ficha + aspa propia. El boton «Limpiar» de la cabecera las borra
      // todas, que es demasiado para quitarse de encima una sola busqueda
      // mal escrita. Y son dos botones hermanos, no uno dentro de otro:
      // anidarlos es HTML invalido y el navegador desmonta el interior.
      var wrap = document.createElement('span');
      wrap.className = 'df-search-modal__recent';

      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'df-chip df-search-modal__chip df-search-modal__chip--recent';
      b.setAttribute('data-df-search-suggest', q);
      b.textContent = q;

      var x = document.createElement('button');
      x.type = 'button';
      x.className = 'df-search-modal__recent-x';
      x.setAttribute('aria-label', 'Quitar "' + q + '" de recientes');
      x.innerHTML = '<svg viewBox="0 0 24 24" width="11" height="11" fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';
      x.addEventListener('click', function (ev) {
        ev.stopPropagation();
        dropRecent(q);
      });

      wrap.appendChild(b);
      wrap.appendChild(x);
      recentChips.appendChild(wrap);
    });
  }

  // === KEYBOARD NAV ===
  function onKeyDown(e) {
    if (e.key !== 'ArrowDown' && e.key !== 'ArrowUp' && e.key !== 'Enter') return;
    // Solo lo que se ve: las respuestas rápidas viven en el DOM aunque estén
    // ocultas, y las flechas no deben pararse en un enlace invisible.
    var items = Array.prototype.filter.call(modal.querySelectorAll('[data-df-search-result]'), function (el) {
      return el.getClientRects().length > 0;
    });
    if (!items.length) return;
    var active = modal.querySelector('[data-df-search-result].is-active');
    var idx = active ? items.indexOf(active) : -1;
    if (e.key === 'ArrowDown') { e.preventDefault(); idx = Math.min(items.length - 1, idx + 1); }
    if (e.key === 'ArrowUp')   { e.preventDefault(); idx = Math.max(0, idx - 1); }
    // `click()` y no `location.href`: así pasa por el mismo sitio que el
    // ratón (guarda la reciente, mide la búsqueda) y respeta el `target` del
    // enlace de WhatsApp.
    if (e.key === 'Enter' && active && items.indexOf(active) !== -1) { e.preventDefault(); active.click(); return; }
    items.forEach(function (it) { it.classList.remove('is-active'); });
    if (items[idx]) {
      items[idx].classList.add('is-active');
      items[idx].scrollIntoView({ block: 'nearest', behavior: 'smooth' });
    }
  }

  // === TRACKING ===
  function trackSearch(q) {
    try {
      if (window.dataLayer) window.dataLayer.push({ event: 'search', search_term: q });
      if (window.gtag) window.gtag('event', 'search', { search_term: q });
      if (window.TripleWhale && window.TripleWhale.track) window.TripleWhale.track('search', { search_term: q });
    } catch (e) {}
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
